import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { LegendBoxContentsName, LegendBoxList, LegendCssSquareIconListItem, LegendListDivider } from "../../legend/LegendBoxComponents";
import { memo } from "react";

function LegendRadar() {
  const {t} = useTranslation();
  return (
    <>
      <Box sx={{minWidth: 115}}>
        <LegendBoxContentsName>{t("Precipitation")} (mm/h)</LegendBoxContentsName>
      </Box>
      <Box sx={{display: "flex"}}>
        <LegendBoxList>
          <LegendCssSquareIconListItem background={'rgba(255,0,255, 0.47)'} text={<>80</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(244,0,161, 0.47)'} text={<>64</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(255,0,0, 0.47)'} text={<>56</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(255,21,6, 0.47)'} text={<>48</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(255,140,0, 0.47)'} text={<>40</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(255,165,0, 0.47)'} text={<>32</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(255,191,0, 0.47)'} text={<>24</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(255,255,0, 0.47)'} text={<>16</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(135,255,6, 0.47)'} text={<>12</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(0,255,0, 0.47)'} text={<>8</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(6,207,34, 0.47)'} text={<>4</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(0,0,255, 0.47)'} text={<>2</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(30,144,255, 0.47)'} text={<>1</>}></LegendCssSquareIconListItem>
          <LegendListDivider />
          <LegendCssSquareIconListItem background={'rgba(0,255,255, 0.47)'} text={<></>}></LegendCssSquareIconListItem>
        </LegendBoxList>
      </Box>
    </>
  )
}

export default memo(LegendRadar);